var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createReducer } from '@reduxjs/toolkit';
import { addItemToArray } from '../../scripts/utils';
var initialState = null;
export default createReducer(initialState, {
    // 'collection/create/pending': (_, action: PayloadAction<Collection>) => {
    // 	return action.payload
    // },
    'collection/load/pending': function () { return null; },
    'collection/load/fulfilled': function (_, action) {
        return action.payload;
    },
    'collection/load/rejected': function () {
        return null;
    },
    'collection/deselect': function () {
        return null;
    },
    'collection/rename/pending': function (state, action) {
        var newName = action.meta.arg;
        state.name = newName;
    },
    // 'collection/updatePublicSetting/fulfilled': (
    // 	_,
    // 	action: PayloadAction<Collection>
    // ) => {
    // 	return action.payload
    // },
    'collection/delete/pending': function () { return initialState; },
    'section/create/pending': function (state, action) {
        var _a;
        var newSection = action.payload;
        state.sectionOrder = __spreadArray(__spreadArray([], (state.sectionOrder || []), true), [newSection.id], false);
        state.sections = __assign(__assign({}, state === null || state === void 0 ? void 0 : state.sections), (_a = {}, _a[newSection.id] = newSection, _a));
    },
    // 'section/rename': (
    // 	state,
    // 	action: PayloadAction<{ updatedSection: Section }>
    // ) => {
    // 	const newSection = action.payload.updatedSection
    // 	state!.sections![newSection.id] = newSection
    // },
    'section/delete/pending': function (state, action) {
        var sectionId = action.payload.sectionId;
        var _a = state.sections, _b = sectionId, omit = _a[_b], remainingSections = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        state.sections = remainingSections;
        var newSectionOrder = (state.sectionOrder || []).filter(function (id) { return sectionId !== id; });
        state.sectionOrder = newSectionOrder;
    },
    'image/upload/pending': function (state, action) {
        var _a;
        var newImage = action.payload.imagePlaceholder;
        var sectionId = action.payload.sectionId;
        state.images = __assign(__assign({}, state === null || state === void 0 ? void 0 : state.images), (_a = {}, _a[newImage.id] = newImage, _a));
        state.sections[sectionId].imageOrder = __spreadArray(__spreadArray([], (state.sections[sectionId].imageOrder || []), true), [
            newImage.id,
        ], false);
    },
    'image/upload/fulfilled': function (state, action) {
        var image = action.payload;
        state.images[image.id] = image;
    },
    'image/upload/rejected': function (state, action) {
        var _a = action.payload, imageId = _a.imageId, sectionId = _a.sectionId;
        var imageOrder = state.sections[sectionId].imageOrder || [];
        var newImageOrder = imageOrder.filter(function (id) { return id !== imageId; });
        state.sections[sectionId].imageOrder = newImageOrder;
    },
    // 'image/rename': (state, action: PayloadAction<{ updatedImage: Image }>) => {
    // 	const { updatedImage } = action.payload
    // 	state!.images![updatedImage.id] = updatedImage
    // },
    'image/move/drag': function (state, action) {
        var _a = action.payload, itemId = _a.itemId, origin = _a.origin, destination = _a.destination;
        if (!state)
            return state;
        // remove image from previous position
        state.sections[origin.sectionId].imageOrder.splice(state.sections[origin.sectionId].imageOrder.findIndex(function (_id) { return _id === itemId; }), 1);
        if ('sectionId' in destination && destination.sectionId) {
            // add it to the new position
            state.sections[destination.sectionId].imageOrder = addItemToArray(state.sections[destination.sectionId].imageOrder || [], [itemId], destination.index);
        }
    },
    'collection/rearrangeCollection': function (_, action) {
        return action.payload.updatedCollection;
    },
    'image/delete': function (state, action) {
        var _a = action.payload, sectionId = _a.sectionId, imageIdArray = _a.imageIdArray;
        state.sections[sectionId].imageOrder = state.sections[sectionId].imageOrder.filter(function (id) { return !imageIdArray.includes(id); });
    },
    'auth/signOut': function () { return initialState; },
});
